import * as React from "react"

export default function Dialog({ open, title, onClose, children }) {
  React.useEffect(() => {
    if (!open) return

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.()
    }

    // Disable body scroll when dialog is open
    const originalStyle = window.getComputedStyle(document.body)
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${window.scrollY}px`
    document.body.style.width = '100%'

    window.addEventListener("keydown", onKeyDown)
    
    return () => {
      window.removeEventListener("keydown", onKeyDown)
      
      // Restore body scroll when dialog closes
      const scrollY = document.body.style.top
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto"
      role="dialog"
      aria-modal="true"
      aria-label={title || "Dialog"}
    >
      <button
        type="button"
        className="absolute inset-0 bg-black/80"
        onClick={onClose}
        aria-label="Close dialog"
      />
      <div className="relative mx-4 my-8 w-full max-w-4xl rounded-xl border border-slate-800 bg-black text-white shadow-2xl max-h-[calc(100vh-4rem)] overflow-y-auto">
        {title ? (
          <div className="flex items-center justify-between border-b border-slate-800 px-5 py-4">
            <h2 className="text-base font-medium">{title}</h2>
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border border-slate-800 bg-slate-900/40 px-3 py-1.5 text-sm text-slate-100 hover:border-slate-700"
            >
              Close
            </button>
          </div>
        ) : null}
        <div className="p-5">{children}</div>
      </div>
    </div>
  )
}
